import { render, staticRenderFns } from "./mixColorMask.vue?vue&type=template&id=56d0e2f2&scoped=true"
var script = {}
import style0 from "./mixColorMask.vue?vue&type=style&index=0&id=56d0e2f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0e2f2",
  null
  
)

export default component.exports